<template>
  <div class="IssueProduct">
    <top />
    <div class="header">
      <div class="w">
        <div class="logo">
          <router-link to="/"> www.rakumart-2c.com</router-link>

        </div>
        <div class="head">
          <h3>問題商品</h3>
          <div class="nav">
            <div class="item" :class="{ index: index == 1 }" @click="getIndex(1)">
              未処理 <span>（{{ num.notDeal ? num.notDeal : 0 }}）</span>
            </div>
            <div class="item" :class="{ index: index == 2 }" @click="getIndex(2)">
              処理中 <span>（{{ num.hasDeal ? num.hasDeal : 0 }}）</span>
            </div>
            <div class="item" :class="{ index: index == 0 }" @click="getIndex(0)">
              進行中 <span>（{{ num.total ? num.total : 0 }}）</span>
            </div>
            <div class="item" :class="{ index: index == 3 }" @click="getIndex(3)">
              完了済み <span> （{{ num.complete ? num.complete : 0 }}）</span>
            </div>
          </div>
          <!-- 搜索 -->
          <div class="search fr">
            <input type="text" placeholder="注文書番号、注文管理番号、受取人" v-model="list.searchText" />
            <button @click="clientMondaiList">确定</button>
          </div>
        </div>
      </div>
    </div>
    <div class="main">
      <div class="w" :class="{ phone: isPhone }" style="margin-top: 20px">
        <!-- 列表 -->
        <div class="list" v-if="total">
          <div class="item" v-for="(item, index) in lists" :key="index">
            <!-- 详情 -->
            <div class="detail">
              <img :src="item.pic" alt="" />
              <div class="text">
                <!-- 状态 -->
                <div class="state p">
                  <span>NO: {{ item.rowNumber }}</span>
                </div>
                <div class="p">
                  <span>問題提出時間：{{ item.datetime }}</span>
                </div>
                <div class="p">
                  <span>状態：{{ item.statusName }}</span>
                </div>
                <div class="p link">
                  <span>
                    注文書番号：
                    <router-link :to="'/zhuwen?ordno=' + item.ordno" target="_blank">{{ item.ordno }}-{{ item.sorting
                    }}</router-link></span>
                  <button @click="copyUrl(item.ordno + '-' + item.sorting)">コピー</button>
                </div>
                <!-- 链接 -->
                <div class="link p">
                  <a :href="item.type != 'rakumart'
                    ? 'https://www.rakumart-2c.com/#/details1688?iid=' +
                    item.iid +
                    '&type=' +
                    item.type
                    : ''
                    " target="_blank">
                    {{
                      item.type != "rakumart"
                        ? "www.rakumart-2c.com/#/details1688?iid=" +
                        item.iid +
                        "&type=" +
                        item.type
                        : ""
                    }}
                  </a>
                </div>
              </div>
            </div>
            <div class="shuxing">
              <div class="color-size">
                <div class="item">
                  <span> カラー:</span>
                  <input type="text" disabled v-model="item.color" />
                </div>
                <div class="item">
                  <div class="items">数量：{{ item.num }}</div>
                  <div class="items">在库：{{ item.zaiko }}</div>
                </div>
              </div>
              <div class="color-size">
                <div class="item">
                  <span> サイズ:</span>
                  <input type="text" disabled v-model="item.psize" />
                </div>
                <div class="item">
                  <div class="items">問題数：{{ item.m_num }}</div>
                  <div class="items">単価：{{ item.price }}</div>
                </div>
              </div>
              <div class="color-size border-no">
                <div class="item">
                  <span>備考:</span>
                  <input type="text" style="width: 80%" disabled v-model="item.bei" />
                </div>
              </div>
            </div>
            <!-- 图组 -->
            <div class="imgList">
              <div class="img" v-if="item.img">
                <!-- <pic-zoom
                :url="'https://www.rakumart-2c.com/' + item.img"
                :scale="3"
              ></pic-zoom> -->

                <img :src="item.img.substr(0, 4) == 'http'
                  ? item.img
                  : 'https://www.rakumart-2c.com/' + item.img
                  " alt="" @click="
                    handlePictureCardPreview(
                      item.img.substr(0, 4) == 'http'
                        ? item.img
                        : 'https://www.rakumart-2c.com/' + item.img
                    )
                    " />
              </div>
              <div class="img" v-if="item.img1">
                <img :src="item.img1.substr(0, 4) == 'http'
                  ? item.img1
                  : 'https://www.rakumart-2c.com/' + item.img1
                  " alt="" @click="
                    handlePictureCardPreview(
                      item.img1.substr(0, 4) == 'http'
                        ? item.img1
                        : 'https://www.rakumart-2c.com/' + item.img1
                    )
                    " />
              </div>
              <div class="img" v-if="item.img2">
                <img :src="item.img2.substr(0, 4) == 'http'
                  ? item.img2
                  : 'https://www.rakumart-2c.com/' + item.img2
                  " alt="" @click="
                    handlePictureCardPreview(
                      item.img2.substr(0, 4) == 'http'
                        ? item.img2
                        : 'https://www.rakumart-2c.com/' + item.img2
                    )
                    " />
              </div>
              <div class="img" v-if="item.img3">
                <img :src="item.img3.substr(0, 4) == 'http'
                  ? item.img3
                  : 'https://www.rakumart-2c.com/' + item.img3
                  " alt="" @click="
                    handlePictureCardPreview(
                      item.img3.substr(0, 4) == 'http'
                        ? item.img3
                        : 'https://www.rakumart-2c.com/' + item.img3
                    )
                    " />
              </div>
              <div class="img" v-if="item.img4">
                <img :src="item.img4.substr(0, 4) == 'http'
                  ? item.img4
                  : 'https://www.rakumart-2c.com/' + item.img4
                  " alt="" @click="
                    handlePictureCardPreview(
                      item.img4.substr(0, 4) == 'http'
                        ? item.img4
                        : 'https://www.rakumart-2c.com/' + item.img4
                    )
                    " />
              </div>
              <div class="img" v-if="item.img5">
                <img :src="item.img5.substr(0, 4) == 'http'
                  ? item.img5
                  : 'https://www.rakumart-2c.com/' + item.img5
                  " alt="" @click="
                    handlePictureCardPreview(
                      item.img5.substr(0, 4) == 'http'
                        ? item.img5
                        : 'https://www.rakumart-2c.com/' + item.img5
                    )
                    " />
              </div>
            </div>
            <!-- 备注 -->
            <div class="bei">
              <textarea placeholder="担当者コメント" disabled v-model="item.y_fan" style="padding: 5px"></textarea>
            </div>
            <!-- 按钮 -->
            <div class="btn" v-if="item.status == 1">
              <button @click="clientDeal(item, 1)">受け入れ</button>
              <button @click="clientDeal(item, 3)">キャンセル返金</button>
              <button @click="clientDeal(item, 2)">交換</button>
            </div>
            <!-- 处理完 -->
            <div class="dispose" v-else>
              <h6>
                返答済み
                <span>*返答内容変更される場合は担当者までご連絡ください。</span>
              </h6>
              <div class="row">
                <span>お客様返答：</span>
                <div class="kefu">
                  <b v-if="item.k_bei_type == 1">受け入れ</b>
                  <b v-else-if="item.k_bei_type == 2">交換</b>
                  <b v-else-if="item.k_bei_type == 3">キャンセル返金</b>
                </div>
              </div>
              <div class="row" v-for="(url, urlIndex) in item.link_detail" :key="urlIndex">
                <span>別店舗の場合：</span>
                <p class="input">
                  <a :href="url.jump" target="_blank">{{ url.link }}</a>
                  <textarea disabled v-model="url.remark"></textarea>
                </p>
              </div>
              <div class="row">
                <span>备注：</span>
                <textarea placeholder="コメントが必要な場合のみご記 入ください" disabled v-model="item.k_bei"></textarea>
              </div>
            </div>
          </div>
        </div>
        <!-- 没有数据 -->
        <div class="error" v-else>問題商品ありません</div>
        <!-- 分页 -->
        <div class="fenye">
          <el-pagination background @current-change="handleCurrentChange" @size-change="handleSizeChange"
            :current-page="list.page" :page-size="list.pageSize" layout="total,  prev, pager, next, jumper"
            :total="total"></el-pagination>
        </div>
      </div>
    </div>
    <!-- 接受 -->
    <el-dialog title="受け入れ" :visible.sync="jieshoudialogVisible" width="500px" center>
      <div class="text-box">
        <textarea placeholder="コメントが必要な場合のみご記 入ください" v-model="datas.k_bei"></textarea>
      </div>
      <span slot="footer" class="dialog-footer">
        <button @click="jieshoudialogVisible = false">取り消し</button>
        <button @click="clientDealResult" class="queding">確 定</button>
      </span>
    </el-dialog>
    <!-- 退货 -->
    <el-dialog title="キャンセル返金" :visible.sync="tuihuodialogVisible" width="500px" center>
      <div class="text-box">
        <textarea placeholder="コメントが必要な場合のみご記 入ください" v-model="datas.k_bei"></textarea>
      </div>
      <span slot="footer" class="dialog-footer">
        <button @click="tuihuodialogVisible = false">取り消し</button>
        <button @click="clientDealResult" class="queding">確 定</button>
      </span>
    </el-dialog>
    <!-- 换货 -->
    <el-dialog title="交換" :visible.sync="huanhuodialogVisible" width="700px" center>
      <div class="text-box">
        <div class="ipt" v-for="(item, index) in urlList" :key="index">
          <span>別店舗の場合：</span>
          <div class="url">
            <input type="text" placeholder="URL記入" v-model="item.link" />
            <p style="margin-top: 20px;" v-if="item.jump">
              <a :href="item.jump" target="_blank">
                <button>
                  詳細
                </button>
              </a>
            </p>
          </div>

          <textarea v-model="item.remark" disabled></textarea>
          <!-- 删除 -->
          <i class="el-icon-error" @click="del(index)"></i>
        </div>
        <!-- 添加 -->
        <div class="add">
          <i class="el-icon-circle-plus" @click="addUrl"></i>
        </div>
        <textarea placeholder="コメントが必要な場合のみご記 入ください" v-model="datas.k_bei"></textarea>
      </div>
      <span slot="footer" class="dialog-footer">
        <button @click="huanhuodialogVisible = false">取り消し</button>
        <button @click="clientDealResult" class="queding">確 定</button>
      </span>
    </el-dialog>
    <!-- 查看大图 -->
    <el-dialog :visible.sync="imgDialogVisible">
      <img width="100%" :src="dialogImageUrl" alt="" />
    </el-dialog>
  </div>
</template>
<script>
import top from "../../../components/head/Top.vue";
// import PicZoom from "vue-piczoom";

import {
  clientMondaiList,
  clientDealResult,
  clientMondaiListCount,
} from "../../../api/API/IssueProduct";
export default {
  data() {
    return {
      huanhuodialogVisible: false,
      tuihuodialogVisible: false,
      jieshoudialogVisible: false,
      imgDialogVisible: false,
      dialogImageUrl: "",
      index: 1,
      isPhone: false,
      list: {
        token: localStorage.getItem("token"),
        status: 1,
        searchText: "",
      },
      datas: {
        token: localStorage.getItem("token"),
        k_bei: "",
      },
      num: {
        notDeal: "0", //待处理
        hasDeal: "0", //已处理
        total: 0, //全部
        complete: 0,
      },
      urlList: [],
      lists: [],
      total: 1,
    };
  },
  components: {
    top,
    // PicZoom,
  },
  created() {
    // 判断是否是手机登录的
    if (this.isMobilefun()) {
      this.isPhone = true;
      console.log(123);
    }
    this.clientMondaiList();
    // 获取数量统计
    clientMondaiListCount({ token: localStorage.getItem("token") }).then(
      (res) => {
        this.num = res.data;
      }
    );
  },

  methods: {
    //  切换状态
    getIndex(i) {
      this.index = i;
      this.list.status = i;
      this.list.page = 1;
      this.clientMondaiList();
    },

    // 请求数据
    clientMondaiList() {
      clientMondaiList(this.list).then((res) => {
        this.lists = res.data.data;
        this.total = res.data.total;
      });
    },
    // 复制url
    copyUrl(data) {
      let url = data;
      let oInput = document.createElement("input");
      oInput.value = url;
      document.body.appendChild(oInput);
      oInput.select(); // 选择对象;
      console.log(oInput.value);
      document.execCommand("Copy"); // 执行浏览器复制命令
      this.$message({
        message: "クリップボードへのコピーに成功しました",
        type: "success",
      });
      oInput.remove();
    },
    // 选择数量
    handleSizeChange(val) {
      this.list.pageSize = val;
      this.clientMondaiList();
    },
    // 选择页
    handleCurrentChange(val) {
      this.list.page = val;
      this.clientMondaiList();
    },
    isMobilefun() {
      let flag = navigator.userAgent.match(
        /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
      );
      return flag;
    },
    clientDeal(item, i) {
      console.log(i);
      this.datas.id = item.id;
      this.datas.type = i;
      this.datas.k_bei = "";
      this.datas.links = [];
      this.urlList = [];
      console.log(this.datas);
      if (i == 1) {
        this.jieshoudialogVisible = true;
      } else if (i == 2) {
        this.huanhuodialogVisible = true;
        if (item.link_detail != false) {
          item.link_detail.forEach((item) => {
            this.urlList.push(item);
          });
        } else {
          this.urlList.push({ link: "", jump: "", remark: "" });
        }
      } else {
        this.tuihuodialogVisible = true;
      }
    },
    // 添加url
    addUrl() {
      if (this.urlList.length >= 3) {
        return false;
      }
      this.urlList.push({ link: "", jump: "", remark: "" });
    },
    // 删除url
    del(i) {
      this.urlList.splice(i, 1);
    },
    // 各种状态提交
    clientDealResult() {
      this.urlList.forEach((item) => {
        this.datas.links.push(item);
      });
      clientDealResult(this.datas).then((res) => {
        if (res.code != 0) return this.$message.error(res.msg);
        this.jieshoudialogVisible = false;
        this.tuihuodialogVisible = false;
        this.huanhuodialogVisible = false;
        this.$message.success("操作に成功する");
        this.clientMondaiList();
      });
    },
    // 查看大图
    handlePictureCardPreview(url) {
      console.log(url);
      this.dialogImageUrl = url;
      this.imgDialogVisible = true;
    },
  },
};
</script>
<style>
body {
  background-color: #f9f9f9;
  font-size: 14px;
}
</style>
<style lang='scss' scoped>
.header {
  background-color: #fff;
  margin-bottom: 20px;

  .logo {
    margin: 17px 0 40px;
    height: 100px;

    a {
      color: #f3c622;
      font-size: 30px;
      line-height: 100px;
    }

    img {
      width: 198px;
    }
  }

  .head {
    padding-bottom: 20px;
    background-color: #fff;
    height: 60px;
    line-height: 60px;
    border-radius: 5px;

    h3 {
      width: 210px;
      font-size: 25px;
      float: left;
    }

    .nav {
      float: left;

      .item {
        float: left;
        font-size: 14px;
        margin-right: 35px;
        line-height: 57px;
        cursor: pointer;

        span {
          color: #b4272d;
        }
      }

      .index {
        color: #b4272d;
      }
    }

    .search {
      float: right;

      input {
        width: 290px;
        height: 34px;
        border: 1px solid #f3c622;
        border-radius: 3px;
        margin-right: 10px;
        padding-left: 10px;
      }
    }
  }
}

button {
  border: 0;
  padding: 0 26px;
  cursor: pointer;
  height: 36px;
  background: #f3c622;
  border-radius: 2px;
  color: #222;
}

.main {
  background: #f9f9f9;

  .list {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;

    .item {
      width: 650px;
      margin-bottom: 20px;
      padding: 20px;
      background-color: #fff;

      .detail {
        overflow: hidden;
        padding-bottom: 20px;

        img {
          width: 200px;
          height: 200px;
          margin-right: 30px;
          float: left;
        }

        .text {
          float: left;
          width: 420px;
          font-size: 14px;

          span {
            margin-right: 15px;
          }

          .p {
            margin-bottom: 5px;
          }

          .link {
            a {
              color: #b4272d;
            }
          }
        }
      }

      .shuxing {
        .color-size {
          display: flex;
          line-height: 30px;
          margin-bottom: 10px;
          font-size: 14px;

          .item {
            margin: 0;
            padding: 0;
            display: flex;

            .items {
              flex: 1;
            }
          }

          span {
            display: inline-block;
            width: 55px;
            margin: 0;
          }

          input {
            height: 32px;
            border: 1px solid #ccc;
            width: 70%;
            padding-left: 10px;
            background-color: #f9f9f9;
          }
        }
      }

      .imgList {
        margin: 20px 0;
        display: flex;
        flex-wrap: wrap;

        .img {


          &:nth-child(3n) {
            margin-right: 0;
          }

          img {
            width: 200px;
            height: 200px;
            cursor: pointer;
            margin-right: 10px;
            margin-bottom: 10px;
          }
        }
      }

      .bei {
        padding-bottom: 20px;
        border-bottom: 1px solid #ccc;

        textarea {
          width: 99%;
          height: 80px;
          padding: 5px;
          border: 1px solid #ccc;
          resize: none;
          border-radius: 2px;
        }
      }

      .btn {
        text-align: center;
        padding: 20px 0;

        button {
          margin-right: 40px;
          width: 158px;
          height: 48px;
          padding: 0;
          font-size: 18px;

          //   color: #222;
          &:nth-child(2) {
            background-color: #fff;
            border: 1px solid #f3c622;
          }

          &:nth-child(3) {
            background-color: #fff;
            border: 1px solid #222;
          }
        }
      }

      .dispose {
        font-size: 16px;
        padding: 20px 0;

        h6 {
          margin-bottom: 20px;
          font-size: 16px;
          font-size: 700;

          span {
            color: #999;
            margin-left: 10px;
            font-size: 12px;
          }
        }

        .row {
          display: flex;
          margin-bottom: 20px;

          b {
            font-size: 14px;
          }

          span {
            flex: 1.2;
          }

          .kefu {
            flex: 5;
          }

          .input {
            flex: 5;
            border: 1px solid #ccc;
            border-radius: 3px;
            padding-left: 5px;
            display: flex;
            height: 100px;

            a {
              color: #f3c622;
              word-break: break-all;
              flex: 1;
              width: 120px;
            }

            textarea {
              flex: 1;
              margin: 5px 5px 5px 20px;
              height: 80px;
            }
          }

          .kehu {
            flex: 1;
          }

          textarea {
            flex: 5;
            border: 1px solid #ccc;
            padding: 5px;
            border-radius: 3px;
            resize: none;
            height: 80px;
          }
        }
      }
    }

    .margin-right {
      margin-right: 20px;
    }
  }

  .error {
    height: 500px;
    text-align: center;
    line-height: 500px;
    font-size: 30px;
    color: #f3c622;
  }
}

.phone {
  font-size: 28px !important;

  textarea {
    font-size: 20px !important;
  }

  button {
    border: 0;
    height: 50px;
    background: #f3c622;
    padding: 0 40px;

    cursor: pointer;
    border-radius: 5px;
    font-size: 25px;
  }

  input {
    height: 48px !important;
    font-size: 20px;
  }

  b {
    font-size: 30px !important;
  }

  .input {
    height: 48px !important;
    font-size: 20px;
  }

  .nav {
    .item {
      font-size: 25px !important;
    }
  }

  .head {
    margin: 20px 0;
    background-color: #fff;
    height: 120px;
    line-height: 120px;
    border-radius: 5px;

    h3 {
      width: 210px;
      font-size: 25px;
      float: left;
      text-indent: 1em;
    }

    .nav {
      float: left;

      .item {
        float: left;
        font-size: 14px;
        margin-right: 35px;
        line-height: 117px;
        cursor: pointer;
      }

      .index {
        border-bottom: 3px solid #f3c622;
      }
    }

    .search {
      float: right;
      margin-right: 30px;

      input {
        width: 290px;
        height: 28px;
        border: 1px solid #f3c622;
        border-radius: 3px;
        margin-right: 10px;
        padding-left: 10px;
        transform: translate(0, -5px);
      }
    }
  }

  .list {
    .item {
      width: 1380px !important;

      .p {
        margin-bottom: 20px !important;
      }

      img {
        width: 400px !important;
        height: 400px !important;
      }

      .color-size {
        width: 900px !important;

        span {
          width: 120px !important;
        }
      }
    }
  }

  .bei {
    textarea {
      height: 200px !important;
    }
  }

  .row {
    span {
      flex: 1.5 !important;
    }

    .tishi {
      flex: 3 !important;
      font-size: 20px !important;
    }

    textarea {
      height: 400px !important;
    }
  }
}

.fenye {
  margin: 30px auto;
  padding-bottom: 30px;
  text-align: center;

  /deep/.el-pagination.is-background .el-pager li:not(.disabled).active {
    background: #f3c622;
    color: #222;
  }
}

.text-box {
  i {
    color: #f3c622;
    font-size: 25px;
    cursor: pointer;
    transform: translate(0, 3px);
  }

  .ipt {
    margin-bottom: 10px;
    display: flex;

    input {
      width: 280px;
      border: 1px solid #f3c622;
      padding: 0 10px;
      height: 26px;
      margin-right: 10px;
    }

    textarea {
      width: 150px;
      height: 100px;
      margin: 0 15px;
      padding: 5px;
    }
  }

  .add {
    margin: 10px 0;
    text-align: center;
  }

  textarea {
    resize: none;
    width: 95%;
    height: 150px;
    padding: 10px 2.5%;
    border: 1px solid #f3c622;
    border-radius: 5px;
    font-size: 14px;
  }
}

.dialog-footer {
  button {
    margin-right: 30px;
    padding: 5px 20px;
    background-color: #fff;
    border-radius: 3px;
    border: 1px solid #f3c622;
    color: #f3c622;
    font-size: 16px;
    cursor: pointer;
  }

  .queding {
    color: #fff;
    background: #f3c622;
  }
}
</style>